"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyle = void 0;

var _reactJss = require("react-jss");

var _fonts = require("../../styles/fonts");

var _variables = require("../../styles/variables");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyle = (0, _reactJss.createUseStyles)(_objectSpread(_objectSpread({}, _fonts.fontStyles), {}, {
  div: {
    direction: "rtl",
    display: "flex",
    alignItems: "center",
    fontFamily: "IranSansX"
  },
  radioButton: {
    appearance: "none",
    position: "relative",
    marginLeft: "10px",
    width: "22px",
    height: "22px",
    display: "inline-block",
    verticalAlign: "top",
    margin: 0,
    cursor: "pointer",
    border: "1px solid ".concat(_variables.colors.father),
    borderRadius: "50%",
    // "&:before": {
    // 	content: '""',
    // 	position: "absolute",
    // 	border: `1px solid ${colors.father}`,
    // 	borderRadius: "50%",
    // 	width: "21px",
    // 	height: "21px",
    // 	right: "0",
    // 	top: "0",
    // },
    "&:after": {
      content: '""',
      height: "22px",
      width: "22px",
      display: "block",
      left: -1,
      top: -1,
      position: "absolute",
      borderRadius: "50%",
      transition: "transform 300ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, opacity 300ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
      transform: "scale(0.001, 0.001)",
      backgroundColor: _variables.colors.father,
      background: _variables.colors.father,
      opacity: 0
    },
    "&:checked:after": {
      content: '""',
      display: "block",
      left: -1,
      top: -1,
      position: "absolute",
      opacity: 1,
      width: "22px",
      height: "22px",
      backgroundColor: _variables.colors.father,
      background: _variables.colors.father,
      borderRadius: "50%",
      transition: "transform 300ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, opacity 300ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
      transform: "scale(0.48, 0.48)"
    } // "&:checked:after": {
    // content: '""',
    // position: "absolute",
    // backgroundColor: colors.father,
    // borderRadius: "50%",
    // width: "15px",
    // height: "15px",
    // top: "50%",
    // left: "50%",
    // transform: "translate(-50%,-50%)",
    // },

  },
  label: {
    margin: "0",
    display: "inline-block",
    verticalAlign: "top",
    cursor: "pointer"
  }
}), {
  name: 'pds-radio-button'
});
exports.useStyle = useStyle;